import React from 'react';
import { PageSkeleton } from '@/components/base/Skeleton';

/**
 * Full-height loading placeholder. Kept under the original name so the existing
 * call sites keep working, but it now renders a skeleton of the page instead of
 * a spinner — the layout stays put while data arrives.
 */
const LoadingSpinner: React.FC = () => (
  <div className="min-h-screen w-full bg-white p-6 dark:bg-slate-900">
    <PageSkeleton />
  </div>
);

export default LoadingSpinner;
